import { DateTime } from "luxon";
import tools from "../../../helpers/tools";
import useStore from "../../../context/useStore";

export const FORMAT_LONG = "dd/MM/yyyy 'à' HH:mm";
export const FORMAT_COURT = "dd/MM 'à' HH:mm";

const age = (iso) => (iso ? DateTime.fromISO(iso).setLocale("fr").toRelative() : "");

// Date de création, avec son ancienneté relative.
export const Creee = ({ iso }) => (
  <span>
    Créée le <b>{tools.formatDate(iso, FORMAT_LONG)}</b>
    {iso && <> · {age(iso)}</>}
  </span>
);

// Date de dernière modification.
export const Modifiee = ({ iso }) => (iso ? <span>Modifiée le {tools.formatDate(iso, FORMAT_COURT)}</span> : null);

// Motif d'abandon d'un lead annulé (constante LEAD_CANCEL_REASONS et texte libre).
export const MotifAbandon = ({ lead }) => {
  const [state] = useStore();
  const { LEAD_CANCEL_REASONS = [] } = state.constants.items;
  const motif =
    lead.status === "CANCEL" && lead.cancelReason
      ? LEAD_CANCEL_REASONS.find((r) => String(r.id) === String(lead.cancelReason))
      : null;
  if (!motif) return null;
  return (
    <p className="la-carte__motif">
      <i className="fa fa-info-circle" aria-hidden="true" />
      <span>
        Motif d'abandon : {motif.name}
        {lead.cancelText && ` (${lead.cancelText})`}
      </span>
    </p>
  );
};
